import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { User } from '../../shared/user/user.model';
import { BaseService } from '../../shared/base.service';

@Injectable()
export class LoginService extends BaseService {

  constructor(protected http: HttpClient, protected router: Router, protected cookieService: CookieService){
    super( http, router, cookieService );
  }

  public login(email: string, password: string): Observable<HttpResponse<User>>{

    return this.post<HttpResponse<User>>( `/login`, { email, password }, { observe: 'response' as 'body' } );
  }

  public getLoggedUser(id: string): Observable<User>{
    return this.get<User>( `/users/logged/${ id }`, this.httpOptions() );
  }

  public authenticated(): boolean{
    return !!this.cookieService.get( 'idToken' );
  }
}
